import { render, staticRenderFns } from "./FavouriteIcon.vue?vue&type=template&id=755d35c8"
import script from "./FavouriteIcon.vue?vue&type=script&lang=js"
export * from "./FavouriteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('755d35c8')) {
      api.createRecord('755d35c8', component.options)
    } else {
      api.reload('755d35c8', component.options)
    }
    module.hot.accept("./FavouriteIcon.vue?vue&type=template&id=755d35c8", function () {
      api.rerender('755d35c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/FavouriteIcon.vue"
export default component.exports